import styled from 'styled-components'

export const StyledLayout = styled.div`
  position: relative;
  min-height: 100vh;
`
